<template>
  <div>
    <div class="title text-center mt-20 px-2 md:px-0">
      <h1 class="text-2xl md:text-4xl text-b2c-red-300"> {{ $t('configurator.title') }} </h1>
      <h3> {{ $t('configurator.subtitle') }}  </h3>
      <!--<h4 class="px-2 py-3 mt-16 bg-red-300 text-white">
        <strong class="uppercase text-lg"> {{ $t('configurator.workInProgress') }} </strong> <br>
        {{ $t('configurator.comeBack') }}
      </h4>-->
    </div>
    <div v-if="customerHarps.length===0 || seeMoreHarps">
      <div class="flex flex-col md:mt-20 mt-10 relative">
        <div class="flex w-full justify-end md:absolute" v-if="customerHarps.length>0">
          <button @click="seeMoreHarps=false;choosenHarp=customerHarps[0]"
            class="px-4 py-2 hover:text-b2c-red-300 hover:font-medium text-sm rounded">
              {{ $t('configurator.seeYours') }}
          </button>
        </div>
        <h5 class="text-center mb-4 font text-xl uppercase">{{ $t('configurator.chooseHarp') }} </h5>
        <div class="flex flex-col md:flex-row items-center w-full">
          <button
            v-if="choosenBrand!=='salvi'"
            @click="choosenBrand='salvi'; choosenHarp=''"
            class="cursor-pointer flex justify-center md:w-1/2 h-32 bg-b2c-grey-600 p-4 items-center rounded-lg hover:bg-b2c-grey-100"
          >
            <grey-salvi-logo></grey-salvi-logo>
          </button>
          <button
            v-else
            class="cursor-pointer flex justify-center md:w-1/2 h-32 bg-b2c-grey-100 p-4 items-center rounded-lg"
          >
            <grey-salvi-logo></grey-salvi-logo>
          </button>
          <button
            v-if="choosenBrand!=='lyon'"
            @click="choosenBrand='lyon'; choosenHarp=''"
            class="cursor-pointer flex justify-center mt-6 md:mt-0 md:w-1/2 h-32 bg-b2c-grey-600 p-4 md:ml-3 items-center rounded-lg hover:bg-b2c-grey-100"
          >
            <grey-lyon-logo></grey-lyon-logo>
          </button>
          <button
            v-else
            class="cursor-pointer flex justify-center mt-6 md:mt-0 md:w-1/2 h-32 bg-b2c-grey-100 p-4 md:ml-3 items-center rounded-lg"
          >
            <grey-lyon-logo></grey-lyon-logo>
          </button>
        </div>
      </div>
      <div v-if="choosenBrand" class="mt-10 w-full">
        <div class="md:flex items-center mr-4 hidden w-full">
          <button v-for="family in harpsFamilies" :key="family" @click="choosenFamily = family"
            class="px-10 py-4 mx-2 text-xl font-serif rounded-md shadow-md border-none uppercase w-full" :class="familyClass(family)">
              {{ $t('configurator.'+family) }}
          </button>
        </div>
      </div>
      <div v-if="choosenFamily" class="flex flex-col md:flex-row md:flex-wrap lg:flex-nowrap justify-center items-start mx-10 md:mx-0 text-sm mt-10">
        <div v-for="collection in harpsCollectionsByFamily" :key="collection" class="hidden md:block">
          <div class="flex flex-col px-4">
            <h5 class="text-b2c-red-300 pb-2 mt-4 md:mt-0 uppercase"> {{ $t('configurator.'+collection) }} </h5>
            <div v-for="harp in filteredHarpsByCollectionAndFamily(collection)" :key="harp.id">
              <button
                v-if="choosenHarp==harp"
                class="py-1 text-b2c-red-300 font-bold text-left">
                {{ harp.description }}
              </button>
              <button
                v-else
                class="py-1 hover:text-b2c-red-300 text-left" @click="choosenHarp=harp" v-scroll-to="'#harp'">
                  {{ harp.description }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div v-if="choosenBrand" class="flex flex-col md:flex-row md:flex-wrap lg:flex-nowrap justify-center items-start mx-10 md:mx-0 text-sm mt-10">
        <div v-for="(collection, index) in harpsCollectionsByBrand" :key="index" class="md:hidden w-full">
          <div class="flex flex-col px-4 text-left w-full">
            <button class="text-b2c-red-300 pb-2 mt-4 md:mt-0 uppercase flex justify-between items-center w-full"
              @click="changeCollection(collection)">
                {{ $t('configurator.'+collection) }}
                <dropdown-arrow v-if="choosenCollection!==collection" />
                <dropup-arrow v-else />
            </button>
            <div v-if="choosenCollection === collection">
              <div v-for="harp in filteredHarpsByCollection(collection)" :key="harp.id">
                <button
                  v-if="choosenHarp==harp"
                  class="py-1 text-b2c-red-300 font-bold text-left">
                  {{ harp.description }}
                </button>
                <button
                  v-else
                  class="py-1 hover:text-b2c-red-300 text-left" @click="choosenHarp=harp" v-scroll-to="'#harp'">
                    {{ harp.description }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="md:mt-20 mt-10 flex w-full justify-between items-center border-b md:flex-row flex-col">
      <div class="md:flex items-center hidden">
        <button @click="shiftBackHarps()"
          class="w-6 flex justify-start hover:text-b2c-red-300 transform hover:-translate-x-1"
          v-if="offsetStart>0">
            <svg
              width="100%"
              aria-hidden="true"
              focusable="false"
              data-prefix="fas" data-icon="angle-double-left"
              class="svg-inline--fa fa-angle-double-left fa-w-14"
              role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                <path fill="currentColor" d="M223.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L319.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L393.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34zm-192 34l136 136c9.4 9.4 24.6 9.4 33.9 0l22.6-22.6c9.4-9.4 9.4-24.6 0-33.9L127.9 256l96.4-96.4c9.4-9.4 9.4-24.6 0-33.9L201.7 103c-9.4-9.4-24.6-9.4-33.9 0l-136 136c-9.5 9.4-9.5 24.6-.1 34z"></path>
            </svg>
        </button>
        <div class="flex items-center mr-4">
          <button v-for="harp in filteredCustomerHarps" :key="harp.id" @click="choosenHarp=harp"
            class="px-10 py-2 text-xl rounded-t" :class="selectedClass(harp)">
              {{ harp.description }}
          </button>

        </div>
        <button @click="shiftHarps()"
          class="w-6 flex justify-start hover:text-b2c-red-300 transform hover:translate-x-1"
          v-if="customerHarps.length> offsetEnd">
            <svg
              width="100%"
              aria-hidden="true"
              focusable="false"
              data-prefix="fas" data-icon="angle-double-right"
              class="svg-inline--fa fa-angle-double-right fa-w-14"
              role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                <path fill="currentColor" d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34zm192-34l-136-136c-9.4-9.4-24.6-9.4-33.9 0l-22.6 22.6c-9.4 9.4-9.4 24.6 0 33.9l96.4 96.4-96.4 96.4c-9.4 9.4-9.4 24.6 0 33.9l22.6 22.6c9.4 9.4 24.6 9.4 33.9 0l136-136c9.4-9.2 9.4-24.4 0-33.8z"></path>
            </svg>
        </button>
      </div>
       <div class="flex justify-end w-full md:w-auto">
          <button @click="seeMoreHarps=true;choosenHarp=null"
            class="px-4 py-2 hover:text-b2c-red-300 hover:font-medium text-sm rounded">
              {{ $t('configurator.seeMore') }}
          </button>
        </div>
      <div class="md:hidden">
        <custom-select class="mb-4" :options='customerHarpsNames' v-model="choosenHarp" />
      </div>

    </div>
    <div v-if="choosenHarp" class="mb-5">
      <img :src="choosenHarp.image_url" v-if="choosenHarp.image_url" class="pb-5 w-full">
      <h3 id="harp" class="text-xl font-bold text-center mb-4 uppercase">{{choosenHarp.description}}</h3>
      <div class="flex flex-col md:flex-row w-full leading-6 lg:justify-between justify-center items-center">
        <custom-select-configurator class="mb-4" :options='filteredOctaves' v-model="choosenOctave" />
        <custom-select-configurator class="mb-4" :options='filteredNotes' v-model="choosenNote" />
        <custom-select-configurator class="mb-4" :options='filteredMaterials' v-model="choosenMaterial" />
      </div>
      <div class="flex w-full justify-end relative" v-if="choosenOctave || choosenNote || choosenMaterial">
        <button @click="resetConfigurator()"
          class="px-4 py-2 hover:text-b2c-red-200 hover:font-medium text-sm rounded absolute right-0">
            {{ $t('configurator.reset') }}
        </button>
      </div>
    </div>

    <section v-show="isLoading" class="pt-16 md:w-full w-5/6 mx-auto">
      <div class="md:w-1/4 w-5/6 mx-auto md:mx-0">
          <Skeleton :loading="isLoading" lineHeight="2.5" />
        </div>
      <div v-for="i in 7" :key="i">
        <div class="md:pt-10 pt-4">
          <Skeleton :loading="isLoading" lineHeight="5" />
        </div>
        <div class="md:pt-5 pt-2" v-for="j in 2" :key="i*j">
          <Skeleton :loading="isLoading" lineHeight="2" />
        </div>
      </div>
    </section>

    <div id="stringsProducts" class="my-16 w-5/6 md:w-auto mx-auto">
      <div class="md:flex items-center mr-4 border-b hidden" v-if="choosenHarp">
        <button v-for="configuration in harpConfigurations" :key="configuration.string_layout_type_description"
          @click="changeConfiguration(configuration)"
          class="px-10 py-2 text-md font-serif rounded-t uppercase" :class="configurationClass(configuration)">
            {{ $t(`configurator.${configuration.string_layout_type_description}`) }}
        </button>
      </div>
      <div class="md:hidden" v-if="choosenConfiguration">
        <custom-select class="mb-4" :options="harpConfigurations" v-model="choosenConfiguration" :isLoading="isLoading" @input="getConfigurationStrings" />
      </div>
      <!--<div class="w-full flex justify-center md:justify-end mb-8 md:mb-4 mt-10" v-if="choosenConfiguration && (!choosenOctave && !choosenNote && !choosenMaterial)">
        <add-to-cart-button :quantity=1 :title="$t('product.addToCartLayout')" class="text-xs hover:bg-gray-100 hover:text-b2c-red-300 text-left px-2 h-14"/>
      </div>-->
      <div v-if="choosenConfiguration">
        <table v-for="octave in harpOctaves" :key="octave"
          class="w-full shadow-md rounded-md my-10 hidden md:flex md:flex-col"
          v-show="getStringsByGivenOctave(octave).length>0">
          <thead class="bg-b2c-red-200 px-3 pt-3 pb-6 rounded-t-md shadow-md">
            <tr class="flex justify-between items-center w-full">
              <th class="font-serif font-bold rounded-md shadow-md items-center bg-white p-3 w-full uppercase">
                {{ octave }} {{ $t('configurator.octave') }}
              </th>
              <!--<td class="bg-white cursor-pointer text-left hover:bg-gray-100 hover:text-b2c-red-300 transform hover:-translate-y-1 duration-200 shadow-md rounded-md">
                  <add-to-cart-octave-button :quantity=1 class="text-xs" />
              </td>-->
            </tr>
          </thead>
          <tbody class="flex flex-col w-full p-3">
            <tr class="flex justify-between items-center w-full border-b" v-for="string in getStringsByGivenOctave(octave)" :key="string.id">
              <td class="text-left w-1/10 font-bold" v-if="string.product_attributes">{{ JSON.parse(string.product_attributes.attributes).note }}</td>
              <td class="text-left w-1/2" >{{ string.description }}</td>
              <td class="text-left w-1/8">
                <span>
                   {{ formatter.format(getPriceWithVat(string) / 100) }}
                </span>
                <span class="text-b2c-red-300 italic pl-4" v-if="string.is_discounted">
                  -{{ string.discount_rate }}%
                </span>
              </td>
              <td class="flex justify-center w-1/5 py-2">
                <add-to-cart-only-icon-button :product="string" :quantity=1 class="text-xxs w-10 bg-white"
                  v-if="!string.out_of_stock && string.available_for_orders" />
                <span v-if="string.out_of_stock && string.available_for_orders" class="italic text-b2c-red-300 flex justify-center py-4">
                  {{ $t('product.outOfStock') }}
                </span>
                <span v-if="!string.available_for_orders"
                  class="py-4 text-b2c-red-300 text-center italic justify-center flex">
                   {{ $t('product.notAvailable') }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="md:hidden text-sm" v-if="choosenConfiguration">
        <table class="rounded-md shadow-md mb-6 w-full" v-for="octave in harpOctaves" :key="octave"
          v-show="getStringsByGivenOctave(octave).length>0">
          <thead class="flex bg-b2c-red-200 h-20 items-center rounded-t-md">
            <tr class="uppercase flex justify-between w-full">
              <th class="flex justify-center w-full rounded-md shadow-md bg-white h-8 m-3 items-center font-serif">
                {{ octave }} {{ $t('configurator.octave') }}
              </th>
              <!--<th class="flex items-center bg-white rounded-md shadow-md w-1/2 h-8 m-3">
                <add-to-cart-octave-button :quantity=1 class="text-xxs"/>
              </th>-->
            </tr>
          </thead>
          <tbody>
            <tr class="flex justify-between items-center border-b py-2" v-for="string in getStringsByGivenOctave(octave)" :key="string.id">
              <td class="pl-2 font-bold text-xs w-1/8" v-if="string.product_attributes">
                {{ JSON.parse(string.product_attributes.attributes).note }}
              </td>
              <td class="text-xs w-1/2 flex flex-col items-start">
                <span>
                  {{ string.description }}
                </span>
                <div class="flex items-center pt-1">
                  <span class="font-medium">
                    {{ formatter.format(getPriceWithVat(string) / 100) }}
                  </span>
                  <span class="text-b2c-red-300 italic pl-2" v-if="string.is_discounted">
                    -{{ string.discount_rate }}%
                  </span>
                </div>

              </td>
              <td class="flex justify-center w-3/8">
                <add-to-cart-only-icon-button :product="string" :quantity=1 class="w-8 text-sm"
                  v-if="!string.out_of_stock && string.available_for_orders" />
                <span v-if="string.out_of_stock && string.available_for_orders" class="italic text-b2c-red-300 text-center pt-2 text-xs">
                  {{ $t('product.outOfStock') }}
                </span>
                <span v-if="!string.available_for_orders"
                  class="pt-2 text-b2c-red-300 italic text-center text-xs">
                  {{ $t('product.notAvailable') }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import GreySalviLogo from '@/components/graphics/GreySalviLogo.vue';
import GreyLyonLogo from '@/components/graphics/GreyLyonLogo.vue';
import CustomSelectConfigurator from '@/components/graphics/CustomSelectConfigurator.vue';
import CustomSelect from '@/components/graphics/CustomSelect.vue';
import ProductService from '@/services/ProductService';
// import AddToCartButton from '@/components/AddToCartButton.vue';
// import AddToCartOctaveButton from '@/components/AddToCartOctaveButton.vue';
import AddToCartOnlyIconButton from '@/components/AddToCartOnlyIconButton.vue';
import DropdownArrow from '@/components/graphics/DropdownArrow.vue';
import { getCustomerHarps, getHarps } from '@/services/HarpsService';
import { mapActions, mapGetters } from 'vuex';
import axios from 'axios';
import { Skeleton } from '@/components/Skeleton/src/index';
import DropupArrow from '../components/graphics/DropupArrow.vue';

export default {
  metaInfo() {
    const title = this.$t('titles.configurator');
    const description = this.$t('metaDescriptions.configurator');
    return {
      title,
      meta: [
        {
          name: 'description',
          content: description,
        },
      ],
    };
  },

  components: {
    GreySalviLogo,
    GreyLyonLogo,
    CustomSelectConfigurator,
    CustomSelect,
    AddToCartOnlyIconButton,
    DropdownArrow,
    DropupArrow,
    Skeleton,
  },

  data() {
    return {
      choosenBrand: '',
      choosenFamily: '',
      choosenCollection: '',
      choosenHarp: '',

      choosenOctave: '',
      choosenNote: '',
      choosenMaterial: '',

      strings: [],

      customerHarps: [],
      offsetStart: 0,
      offsetEnd: 4,
      visibleHarpsNum: 4,
      seeMoreHarps: false,

      harps: [],
      harpConfigurations: [],
      choosenConfiguration: null,
      harpStrings: [],

      harpOctaves: ['0', '1', '2', '3', '4', '5', '6', '7'],

      isLoading: false,
    };
  },

  computed: {
    ...mapGetters({
      updatedHarps: 'notification/updatedHarps',
      authenticated: 'auth/authenticated',
      customer: 'auth/customer',
      changedLocale: 'auth/changedLocale',
    }),

    octaves() {
      return [
        {
          name: this.$t('configurator.selectOctave').toUpperCase(),
          value: '',
        },
        {
          name: '0',
          value: '0',
        },
        {
          name: '1',
          value: '1',
        },
        {
          name: '2',
          value: '2',
        },
        {
          name: '3',
          value: '3',
        },
        {
          name: '4',
          value: '4',
        },
        {
          name: '5',
          value: '5',
        },
        {
          name: '6',
          value: '6',
        },
        {
          name: '7',
          value: '7',
        },
      ];
    },

    notes() {
      return [
        {
          name: this.$t('configurator.selectNote').toUpperCase(),
          value: '',
        },
        {
          name: 'E',
          value: 'E',
        },
        {
          name: 'D',
          value: 'D',
        },
        {
          name: 'C',
          value: 'C',
        },
        {
          name: 'B',
          value: 'B',
        },
        {
          name: 'A',
          value: 'A',
        },
        {
          name: 'G',
          value: 'G',
        },
        {
          name: 'F',
          value: 'F',
        },
      ];
    },

    filteredOctaves() {
      if (!this.choosenNote && !this.choosenMaterial) return this.octaves;
      return this.octaves.filter((octave) => {
        if (!octave.value) return octave;
        let findOctave = false;
        this.filteredStrings.forEach((string) => {
          if (JSON.parse(string.product_attributes.attributes).octave.toString() === octave.value) {
            findOctave = true;
          }
        });
        if (findOctave) return octave;
        return null;
      });
    },

    filteredNotes() {
      if (!this.choosenOctave && !this.choosenMaterial) return this.notes;
      return this.notes.filter((note) => {
        if (!note.value) return note;
        let findNote = false;
        this.filteredStrings.forEach((string) => {
          if (JSON.parse(string.product_attributes.attributes).note === note.value) {
            findNote = true;
          }
        });
        if (findNote) return note;
        return null;
      });
    },

    filteredMaterials() {
      if (!this.choosenOctave && !this.choosenNote) return this.materials;
      return this.materials.filter((material) => {
        if (!material.value) return material;
        let findMaterial = false;
        this.filteredStrings.forEach((string) => {
          if (JSON.parse(string.product_attributes.attributes).material === material.value) {
            findMaterial = true;
          }
        });
        if (findMaterial) return material;
        return null;
      });
    },

    filteredStrings() {
      if (this.harpStrings.length === 0 && !this.choosenHarp) return this.strings;
      let filteredStrings = this.harpStrings;
      filteredStrings = this.filteredStringsByOctave(filteredStrings);
      filteredStrings = this.filteredStringsByNote(filteredStrings);
      filteredStrings = this.filteredStringsByMaterial(filteredStrings);
      return filteredStrings;
    },

    filteredHarpsByBrand() {
      return this.harps.filter((harp) => harp.brand.slug.toLowerCase() === this.choosenBrand);
    },

    harpsFamilies() {
      const families = [];
      this.filteredHarpsByBrand.forEach((harp) => {
        if (!families.find((family) => family === harp.family)) {
          families.push(harp.family);
        }
      });
      return families.sort();
    },

    harpsCollectionsByBrand() {
      const harpsCollections = [];
      this.filteredHarpsByBrand.forEach((harp) => {
        if (!harpsCollections.find((collection) => collection === harp.product_line)) {
          harpsCollections.push(harp.product_line);
        }
      });
      return harpsCollections.sort();
    },

    filteredHarpsByBrandAndFamily() {
      return this.filteredHarpsByBrand.filter((harp) => harp.family === this.choosenFamily);
    },

    harpsCollectionsByFamily() {
      const harpsCollections = [];
      this.filteredHarpsByBrandAndFamily.forEach((harp) => {
        if (!harpsCollections.find((collection) => collection === harp.product_line)) {
          harpsCollections.push(harp.product_line);
        }
      });
      return harpsCollections.sort();
    },

    materials() {
      const materials = [];
      const firstMaterial = {
        name: this.$t('configurator.selectMaterial').toUpperCase(),
        value: '',
      };
      materials.push(firstMaterial);
      const strings = this.harpStrings ? this.harpStrings : this.strings;
      strings.forEach((string) => {
        if (!materials.find((material) => material.value === JSON.parse(string.product_attributes.attributes).material)) {
          const materialToAdd = {
            name: JSON.parse(string.product_attributes.attributes).material,
            value: JSON.parse(string.product_attributes.attributes).material,
          };
          materials.push(materialToAdd);
        }
      });
      return materials;
    },

    filteredCustomerHarps() {
      return this.customerHarps.slice(this.offsetStart, this.offsetEnd);
    },

    customerHarpsNames() {
      const harpsNames = [];
      this.customerHarps.forEach((harp) => {
        harpsNames.push(harp);
      });
      return harpsNames;
    },
  },

  watch: {
    authenticated() {
      if (this.authenticated) {
        this.loadCustomerHarps();
      }
    },

    updatedHarps() {
      if (this.updatedHarps) {
        this.loadCustomerHarps();
        this.updatedCustomerHarps(false);
      }
    },

    choosenOctave() {
      if (this.choosenOctave === '') {
        this.choosenNote = '';
        this.choosenMaterial = '';
      }
    },

    choosenNote() {
      if (this.choosenNote === '') {
        this.choosenOctave = '';
        this.choosenMaterial = '';
      }
    },

    choosenMaterial() {
      if (this.choosenMaterial === '') {
        this.choosenOctave = '';
        this.choosenNote = '';
      }
    },

    changedLocale() {
      if (this.choosenConfiguration) {
        this.isLoading = true;
        this.getConfigurationStrings(this.choosenConfiguration);
      }
    },

    choosenFamily() {
      if (this.customerHarps.length === 0 || this.seeMoreHarps) {
        this.choosenHarp = '';
      }
    },

    choosenBrand() {
      this.choosenFamily = '';
    },

    choosenHarp() {
      this.resetConfigurator();
    },

    filteredOctaves() {
      if (this.filteredOctaves.length === 2) {
        this.choosenOctave = this.filteredOctaves[1].value;
      }
    },

    filteredNotes() {
      if (this.filteredNotes.length === 2) {
        this.choosenNote = this.filteredNotes[1].value;
      }
    },

    filteredMaterials() {
      if (this.filteredMaterials.length === 2) {
        this.choosenMaterial = this.filteredMaterials[1].value;
      }
    },
  },

  created() {
    ProductService.getStrings()
      .then((response) => {
        this.strings = response.data;
      })
      .catch(() => {
        this.createNotification('error', `${this.$t('notifications.errorReload')}`);
      });

    getHarps().then(({ data }) => {
      this.harps = data;
    }).catch(() => {
      this.createNotification('error', `${this.$t('notifications.errorReload')}`);
    });
  },

  mounted() {
    if (this.customer) this.loadCustomerHarps();
  },

  methods: {
    ...mapActions({
      updatedCustomerHarps: 'notification/updatedHarps',
    }),

    resetConfigurator() {
      this.resetSelects();
      this.resetConfiguration();
    },

    resetSelects() {
      this.choosenOctave = '';
      this.choosenNote = '';
      this.choosenMaterial = '';
    },

    resetConfiguration() {
      this.choosenConfiguration = null;
      this.harpConfigurations = [];
      if (this.choosenHarp) this.getHarpConfigurations();
    },

    getStringByGivenSku(sku) {
      return this.filteredStrings.find((string) => string.sku === sku);
    },

    loadCustomerHarps() {
      getCustomerHarps(this.customer.id).then(({ data }) => {
        this.customerHarps = data;
        if (!this.customerHarps || this.customerHarps.length <= 0) {
          this.$modal.show('add-harp');
          return;
        }
        const harp = this.customerHarps[0];
        this.choosenHarp = harp;
      }).catch(() => {
        this.$store.dispatch('auth/me');
      });
    },

    filteredHarpsByCollection(collection) {
      return this.filteredHarpsByBrand.filter((harp) => harp.product_line === collection);
    },

    filteredHarpsByCollectionAndFamily(collection) {
      return this.filteredHarpsByBrandAndFamily.filter((harp) => harp.product_line === collection);
    },

    getStringsByGivenOctave(octave) {
      return this.filteredStrings.filter((string) => JSON.parse(string.product_attributes.attributes).octave.toString() === octave);
    },

    filteredStringsByOctave(strings) {
      return strings.filter((string) => {
        if (!this.choosenOctave || JSON.parse(string.product_attributes.attributes).octave.toString() === this.choosenOctave) {
          return string;
        }
        return null;
      });
    },

    filteredStringsByNote(strings) {
      return strings.filter((string) => {
        if (!this.choosenNote || JSON.parse(string.product_attributes.attributes).note === this.choosenNote) {
          return string;
        }
        return null;
      });
    },

    filteredStringsByMaterial(strings) {
      return strings.filter((string) => {
        if (!this.choosenMaterial || JSON.parse(string.product_attributes.attributes).material === this.choosenMaterial) {
          return string;
        }
        return null;
      });
    },

    getHarpConfigurations() {
      this.isLoading = true;
      axios({
        method: 'get',
        url: `${process.env.VUE_APP_AITEMS_URL}${this.choosenHarp.harp_code}`,
        headers: {
          accept: 'application/json',
          Authorization: process.env.VUE_APP_AITEMS_AUTHORIZATION,
        },
      }).then(({ data }) => {
        if (data.length > 0) {
          this.harpConfigurations = data;
          const configuration = this.harpConfigurations[0];
          this.choosenConfiguration = configuration;
          this.getConfigurationStrings(configuration);
          return;
        }
        this.isLoading = false;
        this.createNotification('info', `${this.$t('notifications.noStringsLayout')}`);
      }).catch(() => {
        this.isLoading = false;
        this.createNotification('info', `${this.$t('notifications.noStringsLayout')}`);
      });
    },

    getConfigurationStrings(configuration) {
      // this.resetSelects();
      this.isLoading = true;
      this.harpStrings = [];
      const skues = [];
      configuration.single_string_layouts.forEach((string) => {
        skues.push(string.string_package_code);
      });

      axios.get(`/api/products/skues/?skues=${JSON.stringify(skues)}`)
        .then((response) => {
          Object.keys(response.data).forEach((key) => {
            const string = response.data[key];
            if (string) {
              this.harpStrings.push(string);
            }
          });
          this.isLoading = false;
        }).catch(() => {
          this.isLoading = false;
          // this.createNotification('error', `${this.$t('notifications.errorReload')}`);
        });
    },

    changeConfiguration(configuration) {
      if (this.choosenConfiguration !== configuration) {
        this.choosenConfiguration = configuration;
        this.getConfigurationStrings(configuration);
      }
    },

    shiftHarps() {
      this.offsetStart += this.visibleHarpsNum;
      this.offsetEnd += this.visibleHarpsNum;
    },

    shiftBackHarps() {
      this.offsetEnd -= this.visibleHarpsNum;
      this.offsetStart -= this.visibleHarpsNum;
    },

    chooseBrand(brand) {
      if (brand === 'salvi') {
        this.salvi = true;
        return;
      }
      this.lyon = true;
    },

    selectedClass(harp) {
      if (harp.id === this.choosenHarp.id) {
        return 'border-l border-t border-r border-gray-300 -mb-px bg-white font-semibold bg-b2c-red-200 text-white';
      }
      return 'hover:bg-gray-100 bg-white border-r border-t border-l border-gray-300';
    },

    configurationClass(configuration) {
      if (configuration.string_layout_type_description === this.choosenConfiguration.string_layout_type_description) {
        return 'border-l border-t border-r border-gray-300 -mb-px bg-white font-semibold bg-b2c-red-200 text-white';
      }
      return 'hover:bg-gray-100 bg-white border-r border-t border-l border-gray-300';
    },

    familyClass(family) {
      if (family === this.choosenFamily) {
        return 'border-l border-t border-r border-gray-300 -mb-px bg-white font-semibold bg-b2c-red-200 text-white';
      }
      return 'hover:bg-gray-100 bg-white border-r border-t border-l border-gray-300';
    },

    changeCollection(collection) {
      if (this.choosenCollection !== collection) {
        this.choosenCollection = collection;
      } else {
        this.choosenCollection = '';
      }
    },

    getPriceWithVat(string) {
      const vatRate = 100 + string.vat_rate;
      return ((string.price * vatRate) / 100);
    },

  },

};
</script>

<style lang="scss" scoped>
.loader {
  color: transparent !important;
  pointer-events: none;
  position: relative;
}

.loader:after {
  animation: spinAround 500ms infinite linear;
  border: 2px solid #8d8d8d;
  border-radius: 290486px;
  border-right-color: transparent;
  border-top-color: transparent;
  content: "";
  display: block;
  width: 1em;
  height: 1em;
  position: absolute;
  left: calc(50% - (1em / 2));
  top: calc(50% - (1em / 2));
}

@keyframes spinAround {
  from {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}
</style>
